module.exports = __webpack_public_path__ + "static/media/cq_euro.ca234399.svg";